<template>
  <div>
    <div
      v-for="(stage, idx) in sortStages(stages)"
      :key="stage.id"
      class="stage d-flex mb-7 ga-3 bg-white"
      :class="{
        stage__arrow: idx + 1 < stages.length,
      }"
      :style="{ zIndex: idx }">
      <div>
        <v-chip
          class="font-weight-bold sequence"
          :class="{
            'sequence--red': stage.typeId === 2,
            'sequence--blue': stage.typeId === 1,
          }"
          :color="stage.typeId === 1 ? 'info' : 'error'">
          {{ stage.sequence }}
        </v-chip>
      </div>

      <div class="w-100">
        <div class="d-flex justify-space-between align-center ga-3 mb-3">
          <div class="d-flex align-center ga-3">
            <v-chip
              density="compact"
              rounded="lg"
              :color="stage.typeId === 1 ? 'warning' : 'error'">
              <b>{{ stage.type.name }}</b>
            </v-chip>
            <span class="text-disabled">
              <span v-if="stage.duration">Термін {{ stage.duration }} дн.</span>
              <span v-else>Без терміну</span>
            </span>
          </div>

          <div class="d-flex align-center ga-3">
            <create-stage-participant
              v-if="!readonlyParticipants"
              @create="
                $emit('participant-create', {
                  stageId: stage.id,
                  userId: $event,
                })
              "></create-stage-participant>
            <v-btn
              v-if="!readonlyStages"
              v-tooltip="'Редагувати'"
              variant="outlined"
              density="compact"
              icon="mdi-pencil"
              @click="$emit('stage-update', stage)">
            </v-btn>
            <v-btn
              v-if="!readonlyStages"
              v-tooltip="'Видалити'"
              variant="outlined"
              color="error"
              density="compact"
              icon="mdi-delete"
              @click="$emit('stage-delete', stage.id)">
            </v-btn>
          </div>
        </div>

        <div class="d-flex align-center ga-3 flex-wrap">
          <v-chip
            v-for="participant in stage.participants"
            :key="participant.id"
            color="grey"
            rounded="lg"
            :closable="!readonlyParticipants"
            border
            @click:close="
              $emit('participant-delete', {
                stageId: stage.id,
                participantId: participant.id,
              })
            ">
            <div class="d-flex ga-3 align-center">
              <v-avatar class="mr-3" color="indigo-lighten-5" size="25">
                <span
                  class="text-indigo-darken-1 font-weight-bold text-subtitle-2">
                  {{
                    participant.user.name?.[0] + participant.user.surname?.[0]
                  }}
                </span>
              </v-avatar>
              <span class="text-black">
                {{ getPersonName(participant.user, { initials: true }) }}
              </span>
              <span class="text-disabled">{{ participant.user.post }}</span>
            </div>
          </v-chip>
          <div
            v-if="!stage.participants.length"
            class="font-italic text-disabled">
            Учасників ще не додано
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CreateStageParticipant from './CreateStageParticipant.vue'
import { getPersonName } from 'best-modules/utils'
import { sortStages } from './helpers'
import { DocumentTypeRouteStage } from '@/utils/types/documentRoute'

defineOptions({
  name: 'ActiveRoute',
})
defineProps<{
  stages: DocumentTypeRouteStage[]
  readonlyParticipants?: boolean
  readonlyStages?: boolean
}>()
defineEmits<{
  (_name: 'stage-delete', _stageId: number): void
  (_name: 'stage-update', _stage: DocumentTypeRouteStage): void
  (
    _name: 'participant-create',
    _payload: { stageId: number; userId: number }
  ): void
  (
    _name: 'participant-delete',
    _payload: { stageId: number; participantId: number }
  ): void
}>()
</script>

<style lang="scss" scoped>
.stage {
  overflow: visible;
  position: relative;

  &__arrow:after {
    content: '';
    position: absolute;
    left: 16px;
    top: 32px;
    height: calc(100% + -4px);
    width: 2px;
    background: #dfdfdf;
  }
}

.sequence {
  border-width: 2px;
  border-style: solid;

  &--blue {
    border-color: rgb(var(--v-theme-info));
  }
  &--red {
    border-color: rgb(var(--v-theme-error));
  }
}
</style>
